import React from 'react';
import { postAndRetry, getAppInfo } from 'dooh-utils';
import styled, { ThemeProvider } from 'styled-components';
import { Form } from '../dooh-react-utils';
import { preloader } from '../img';
import * as TERMS from './terms';

const FIELDS = [
  { name: 'name', label: 'Ime i prezime', type: 'name' },
  { name: 'email', label: 'E-mail', type: 'email' },
];

const Wrap = styled.div`
  background: url('${() =>
    preloader.get(require('../img/bg.png'))}') no-repeat 0 0;
  padding-top: 500px;

  .Button.SubmitSmall {
    background: url('${p => p.btnbg}') no-repeat 0 0;
    background-size: contain;

    .Tap {
      background: none;
      opacity: 0;
    }
  }
`;

//color: #57463C;
const THEME = {
  buttonTextColor: 'white',
  keyboardBackgroundColor: 'white',
  keyboardTextColor: '#333',
  checkboxInnerColor: 'black',
  checkboxOuterColor: 'white',
  checkboxInvert: false,
  buttonUppercase: true,
  buttonBackground: '#57463C',
  termsLineColor: 'black',
  inputFont: 'boldfont',
  font: 'boldfont',
  termsBackground: 'none',
};

export default class FormScreen extends React.Component {
  render() {
    return (
      <Wrap>
        <ThemeProvider theme={THEME}>
          <Form
            fields={FIELDS}
            onSubmit={this.handleFormSubmit}
            terms={TERMS[getAppInfo().tracking] || ''}
          />
        </ThemeProvider>
      </Wrap>
    );
  }

  handleFormSubmit = data => {
    const { tracking, instance } = getAppInfo();

    if (tracking != null && instance != null) {
      postAndRetry('https://interaktivno.go2digital.hr/api/games/results/', {
        //postAndRetry('/api/games/results/', {
        game_instance: instance,
        value: this.props.time,
        name: data.name,
        form_data: data,
        tracking,
      });

      postAndRetry('https://interaktivno.go2digital.hr/api/games/tracking/', {
        event: 'submit',
        meta: { ...data, time: this.props.time },
        game_instance: instance,
        tracking,
      });
    }

    this.props.update({
      screen: 'thanks',
      name: data.name,
      topList: updateTopList(
        this.props.topListOnline,
        data.name,
        this.props.time
      ),
    });
  };
}

function updateTopList(topList, name, value) {
  topList = [...topList];
  let pos = 0;
  for (; pos < topList.length; pos++) {
    if (value <= topList[pos].value) break;
  }

  let result = { i: pos, value, name, current: true };

  if (pos !== topList.length) {
    topList.splice(pos, 0, result);
  } else {
    topList.push(result);
  }

  return topList;
}
